import {Component} from '@angular/core';
import {Subject} from "rxjs";
import {Router, NavigationEnd} from "@angular/router";
import {ApplicationPropertiesService} from "@synisys/idm-application-properties-service-client-js";
import {takeUntil} from "rxjs/operators";

declare let gtag: Function;

@Component({
	selector: 'sis-app',
	template: require('./app.component.html')
})
export class AppComponent {

	/** Add Google Analytics Script Dynamically */
	private static addGAScript(gaTrackingId: string) {
		const gtagScript: HTMLScriptElement = document.createElement('script');
		gtagScript.async = true;
		gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaTrackingId;
		document.head.appendChild(gtagScript);
		/** Disable automatic page view hit to fix duplicate page view count  **/
		gtag('config', gaTrackingId, {send_page_view: false});
	}

	private _destroy$ = new Subject<void>();

	constructor(public router: Router,
				private applicationPropertiesService: ApplicationPropertiesService) {
	}

	private configureGA(): void {
		this.applicationPropertiesService.loadProjectConfigs()
			.then(configs => {
				if (!!configs['ga']) {
					AppComponent.addGAScript(configs['ga']);
					this.router.events
						.pipe(takeUntil(this._destroy$))
						.subscribe(event => {
								if (event instanceof NavigationEnd) {
									gtag('event', 'page_view', {
										page_path: event.urlAfterRedirects
									});
								}
							}
						);
				}
			});
	}

	ngOnDestroy(): void {
		this._destroy$.next();
		this._destroy$.complete();
	}

	ngOnInit() {
		this.configureGA();
	}
}
